export default "__VITE_ASSET__CCPlZUp4__"